import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getUserTicket, getTicketRuleDetail, postTicketUserUpdate } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'UserTicket',
  components: {},
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, format || 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      oilCodes = oilCodes + '';
      var oilCodeArr = oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    },
    getWeekNames: function getWeekNames(cycleDays) {
      cycleDays = cycleDays + '';
      var arr = cycleDays.split(',');
      var names = '';

      if (arr.length === 0 || arr.length === _this.weekOptions.length) {
        return '不限';
      }

      _this.weekOptions.map(function (o) {
        if (arr.includes(o.value + '')) {
          names += o.label + ',';
        }
      });

      return names.substr(0, names.length - 1);
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getUserTicket,
      type: '',
      ticketTypeOptions: [{
        name: '满减券',
        value: 1
      }, {
        name: '折扣券',
        value: 2
      }, {
        name: '现金券',
        value: 3
      }],
      stepActive: 1,
      multipleSelection: [],
      viewOilFullReduceDialogVisible: false,
      viewOilDiscountDialogVisible: false,
      viewSingleDiscountDialogVisible: false,
      viewOilCashDialogVisible: false,
      viewGoodsFullReduceDialogVisible: false,
      viewGoodsDiscountDialogVisible: false,
      viewGoodsCashDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      timeRangeValueArr: ['00:00:00', '23:59:59'],
      weekOptions: [],
      weekCheckAll: false,
      weekChecked: [],
      stationOptions: [],
      stationCheckAll: false,
      stationIdChecked: [],
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      activityGoodsList: [],
      sellerOptions: [],
      sellerCheckAll: false,
      sellerIdChecked: [],
      formData: {}
    };
  },
  computed: {},
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, sellerOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getDict('oilCode');

              case 2:
                _this3.oilCodesOptions = _context3.sent;
                _context3.next = 5;
                return _this3.getDict('week');

              case 5:
                _this3.weekOptions = _context3.sent;
                _context3.next = 8;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 8:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 12;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 12:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;
                _this3.formData = _this3.initData();

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        ruleType: 0,
        ticketType: 0,
        // 1=满减 2=折扣 3=现金
        ruleStatus: 1,
        // 0=关闭  1=启用
        ticketName: '',
        describe: '',
        ticketValue: '',
        maxDiscountValue: 0,
        limitSales: 1,
        limitSalesValue: 0,
        limitSellers: 1,
        limitGoods: 1,
        limitAddDiscount: 0,
        limitReceive: 0,
        limitFirstUse: 0,
        ticketTimeType: 0,
        dateStart: '',
        dateEnd: '',
        timeStart: '',
        timeEnd: '',
        limitDays: '',
        circleWeek: '',
        remark: '',
        ticketGoodsRule: [],
        ticketSellerRule: []
      };
      return formdata;
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      if (!this.searchInfo.mobile && !this.searchInfo.mainOrderNo) {
        this.$message({
          message: '手机号或订单号不能同时为空',
          type: 'error'
        });
        return;
      }

      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.page = 1;
      this.searchInfo = {};
      this.tableData = [];
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 下一步
    addNext: function addNext() {
      debugger;

      if (this.stepActive < 3) {
        this.stepActive++;
      }
    },
    // 上一步
    addBefore: function addBefore() {
      if (this.stepActive > 1) {
        this.stepActive--;
      }
    },
    // 查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    onView: function onView(row) {
      debugger; // 油品券-满减

      if (row.ticketRule.ruleType == 2 && row.ticketRule.ticketType == 1) {
        this.dialogTitle = '查看油品-满减券';
        this.viewOilFullReduceDialogVisible = true;
        this.handleViewOrUpdateOilTicket(row);
      } // 油品券-折扣


      if (row.ticketRule.ruleType == 2 && row.ticketRule.ticketType == 2) {
        this.dialogTitle = '查看油品-满折券';
        this.viewOilDiscountDialogVisible = true;
        this.handleViewOrUpdateOilTicket(row);
      } // 油品券-现金


      if (row.ticketRule.ruleType == 2 && row.ticketRule.ticketType == 3) {
        this.dialogTitle = '查看油品-现金券';
        this.viewOilCashDialogVisible = true;
        this.handleViewOrUpdateOilTicket(row);
      } // 油品券-单升


      if (row.ticketRule.ruleType == 2 && row.ticketRule.ticketType == 4) {
        this.dialogTitle = '查看油品-单升券';
        this.viewSingleDiscountDialogVisible = true;
        this.handleViewOrUpdateOilTicket(row);
      } // 商品券-满减


      if (row.ticketRule.ruleType == 3 && row.ticketRule.ticketType == 1) {
        this.dialogTitle = '查看商品-满减券';
        this.viewGoodsFullReduceDialogVisible = true;
        this.handleViewOrUpdateGoodsTicket(row);
      } // 商品券-折扣


      if (row.ticketRule.ruleType == 3 && row.ticketRule.ticketType == 2) {
        this.dialogTitle = '查看商品-满折券';
        this.viewGoodsDiscountDialogVisible = true;
        this.handleViewOrUpdateGoodsTicket(row);
      } // 商品券-现金券


      if (row.ticketRule.ruleType == 3 && row.ticketRule.ticketType == 3) {
        this.dialogTitle = '查看商品-现金券';
        this.viewGoodsCashDialogVisible = true;
        this.handleViewOrUpdateGoodsTicket(row);
      }
    },
    onViewSeller: function onViewSeller(row) {
      this.onView(row);
      this.stepActive = 2;
    },
    onViewGoods: function onViewGoods(row) {
      this.onView(row);
      this.stepActive = 3;
    },
    // 删除
    deleteConfirm: function deleteConfirm(row) {
      var _this4 = this;

      console.log(row);
      var that = this;
      postTicketUserUpdate({
        'ID': row.ID,
        'ticketNo': row.ticketNo
      }).then(function (res) {
        if (res.code == 0) {
          _this4.$message({
            message: '删除成功',
            type: 'success'
          });

          _this4.onSubmit();
        }
      });
    },
    handleViewOrUpdateOilTicket: function handleViewOrUpdateOilTicket(row) {
      debugger;
      var that = this;
      getTicketRuleDetail({
        'ticketRuleNo': row.ticketRuleNo,
        'version': row.version
      }).then(function (res) {
        debugger;
        var formData = res.data;
        that.oilCodesChecked = [];
        that.stationIdChecked = [];
        that.weekChecked = []; // 不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

        formData.dateStart = that.$options.filters.formatDate(row.validStartTime, 'yyyy-MM-dd hh:mm:ss');
        formData.dateEnd = that.$options.filters.formatDate(row.validEndTime, 'yyyy-MM-dd hh:mm:ss');
        that.dateRangeValueArr = [formData.dateStart, formData.dateEnd];
        that.timeRangeValueArr = [formData.timeStart, formData.timeEnd];

        if (formData.limitGoods == 1) {
          formData.ticketGoodsRule.forEach(function (item) {
            that.oilCodesChecked.push(parseInt(item.limitGoods));
          });
          that.oilCodesCheckAll = that.oilCodesChecked.length == that.oilCodesOptions;
        }

        if (formData.limitSellers == 1) {
          formData.ticketSellerRule.forEach(function (item) {
            that.stationIdChecked.push(item.sellerId);
          });
          that.stationCheckAll = that.stationIdChecked == that.stationOptions;
        }

        formData.circleWeek.split(',').forEach(function (item) {
          that.weekChecked.push(parseInt(item));
        });
        that.weekCheckAll = that.weekChecked.length == that.weekOptions.length;
        formData.ticketGoodsRule = [];
        formData.ticketSellerRule = [];
        that.formData = formData;
      }, function (error) {});
    },
    handleViewOrUpdateGoodsTicket: function handleViewOrUpdateGoodsTicket(row) {
      debugger;
      var that = this;
      getTicketRuleDetail({
        'ticketRuleNo': row.ticketRuleNo,
        'version': row.version
      }).then(function (res) {
        debugger;
        var formData = res.data;
        that.activityGoodsList = [];
        that.sellerIdChecked = [];
        that.weekChecked = []; // 不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

        formData.dateStart = that.$options.filters.formatDate(row.validStartTime, 'yyyy-MM-dd hh:mm:ss');
        formData.dateEnd = that.$options.filters.formatDate(row.validEndTime, 'yyyy-MM-dd hh:mm:ss');
        that.dateRangeValueArr = [formData.dateStart, formData.dateEnd];
        that.timeRangeValueArr = [formData.timeStart, formData.timeEnd];

        if (formData.limitGoods == 1) {
          formData.ticketGoodsRule.forEach(function (item) {
            that.activityGoodsList.push({
              'goodsName': item.goodsName,
              'spuNo': item.limitGoods
            });
          });
        }

        if (formData.limitSellers == 1) {
          formData.ticketSellerRule.forEach(function (item) {
            that.sellerIdChecked.push(item.sellerId);
          });
          that.sellerCheckAll = that.sellerIdChecked == that.sellerOptions;
        }

        formData.circleWeek.split(',').forEach(function (item) {
          that.weekChecked.push(parseInt(item));
        });
        that.weekCheckAll = that.weekChecked.length == that.weekOptions.length;
        formData.ticketGoodsRule = [];
        formData.ticketSellerRule = [];
        that.formData = formData;
      }, function (error) {});
    },
    closeDialog: function closeDialog() {
      this.stepActive = 1;
      this.viewOilFullReduceDialogVisible = false;
      this.viewOilDiscountDialogVisible = false;
      this.viewSingleDiscountDialogVisible = false;
      this.viewOilCashDialogVisible = false;
      this.viewGoodsFullReduceDialogVisible = false;
      this.viewGoodsDiscountDialogVisible = false;
      this.viewGoodsCashDialogVisible = false;
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.timeRangeValueArr = ['00:00:00', '23:59:59'];
      this.weekChecked = [];
      this.weekCheckAll = false;
      this.stationCheckAll = false;
      this.stationIdChecked = [];
      this.oilCodesCheckAll = false;
      this.oilCodesChecked = [];
      this.activityGoodsList = [];
      this.sellerIdChecked = [];
      this.formData = this.initData();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.onSubmit();
      }
    }
  }
};